import React, { Component } from "react";
import { googleAddSense } from "./homeImages";

class GoogleAddSense extends Component{
	constructor(props){
		super(props);
		this.state={

		}
	}

	render() {
		return (
			<section className="google-ads">
				  <div className="container animate-fade">
				    
				    <h2>Webtalk Ads maximize your earning potential</h2>
				    <p>Getting paid to be social has never been easier</p>
				        <div className="content-img flex">
				          <div className="content-section left-right-anim">
				            
				            <span>benefits</span>
				            <h3>Only the highest paying Ads go live</h3>
				            <p>Boost your revenue by tapping into the largest network of online advertisers who bid for Webtalk’s ad space to reach you and your followers.</p>
				          </div>
				          <div className="img-section slidedown-anim">

				          	<div className="icon-svg left-icon">
				          		<img src={"images/11.svg"} alt=""/>
				          	</div>
				            <img src={googleAddSense.highest_paying.url} alt=""/>
				            <div className="icon-svg right-icon">
				            	<img src={"images/22.svg"} alt=""/>
				            </div>
				          </div>
				        </div>

				        <div className="content-img flex">
				          <div className="img-section slideup-anim">
				          	<div className="icon-svg left-icon">
				          		<img src={"images/33.svg"} alt=""/>
				          	</div>
				            <img src={googleAddSense.ribht_audience.url} alt=""/>
				             <div className="icon-svg right-icon">
				            	<img src={"images/44.svg"} alt=""/>
				            </div>
				          </div>

				          <div className="content-section right-left-anim">
				            
				            <span>benefits</span>
				            <h3>The right ads for your audience</h3>
				            <p>Ads are screened to ensure they’re high quality and relevant to your content or audience, even when viewed on mobile devices. This maximizes your earning potential from the ads displayed.</p>
				          </div>
				           
				        </div>
				 
				  </div>
			</section>
		);
	}

};

export default GoogleAddSense;